import { render, staticRenderFns } from "./SignupPage.vue?vue&type=template&id=6f10ac35&scoped=true"
import script from "./SignupPage.vue?vue&type=script&lang=ts"
export * from "./SignupPage.vue?vue&type=script&lang=ts"
import style0 from "./SignupPage.vue?vue&type=style&index=0&id=6f10ac35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f10ac35",
  null
  
)

export default component.exports